import * as angular from 'angular';
import { SESSION_ID } from '../../config/session-id';
import { app } from '../app';
import { SpAlert } from '../components/sp-alert/sp-alert.model';

app.factory('AuthenticationSharedService', AuthenticationSharedService);

/** @ngInject */
function AuthenticationSharedService(
    $http,
    $location,
    $q,
    $rootScope,
    $state,
    $window,
    Account,
    authService,
    TokenService,
    WebSocket,
) {
                    var gmpLoginSession = false;
                    
                    
                    
                    var setInvalidAttempts = function(data) {
                        if (data.error_description && data.error_description.indexOf('numberOfAttempts') > -1) {
                            const numberOfAttempts = +data.error_description.split('=')[1];
                            localStorage.setItem('loginAttempts', numberOfAttempts);
                        } else {
                            const loginAttempts = +localStorage.getItem('loginAttempts') || 0;
                            localStorage.setItem('loginAttempts', loginAttempts + 1);
                        }
                    };
                    return {
                        
                        sendPushLoginNotification: function (captchaResponse, username, oauthClientId, appKey, saaspassId) {
                            
                            WebSocket.connect();

                            const loginAttempts = +localStorage.getItem('loginAttempts') || 0;
                            localStorage.setItem('loginAttempts', loginAttempts + 1);
                            
                            $rootScope.authenticationError = false;
                            $rootScope.captchaError = false;
                            
                            const deferred = $q.defer();

                            $http.get('app/rest/pushlogin/saaspass',{ params : {
                                username : username,
                                sessionid : SESSION_ID,
                                appKey : appKey,
                                saaspassId : saaspassId,
                                oauth_client_id : oauthClientId,
                                captchaResponse : captchaResponse
                            }, ignoreAuthModule: true })
                            .then(() => deferred.resolve(username))
                            .catch((response) => {
                                const data = response.data;
                                if (response.status === 412) {
                                    if (data.message && data.message.indexOf('numberOfAttempts') > -1) {
                                        const numberOfAttempts = +data.message.split('=')[1];
                                        localStorage.setItem('loginAttempts', numberOfAttempts);
                                    }                                    
                                    $rootScope.captchaError = true;     
                                    $rootScope.captchaErrorMsg = 'login.messages.error.invalid_captcha';
                                } else {                                  
                                    $rootScope.authenticationError = true;                                    
                                }
                                
                                deferred.reject(data.serviceErrorCode);
                            });

                            return deferred.promise;
                        },
                        
                        getGmpLoginSession : function(){
                            return gmpLoginSession;
                        },
                        
                        loginAfterRegistration: function (param) {
                            var username = param.username;
                            var password = param.password;
                            
                            var data = "username="
                                + encodeURIComponent(username)
                                + "&password="
                                + encodeURIComponent(password)
                                + "&grant_type=password&scope=read%20write&client_secret=mySecretOAuthSecret&client_id=SaaSPassapp";
                        if (param.captchaResponse != null) {
                            data += "&captchaResponse=" + param.captchaResponse;
                        }
                        const promise = $http.post(
                                'oauth/token',
                                data,
                                {
                                    headers : {
                                        "Content-Type" : "application/x-www-form-urlencoded",
                                        "Accept" : "application/json",
                                        "Authorization" : `Basic ${btoa('SaaSPassapp:mySecretOAuthSecret')}`
                                    },
                                    ignoreAuthModule : 'ignoreAuthModule'
                                }).then((response) => {
                                   
                            TokenService.setToken(response.data);
                            
                            Account.reload().then(function (data) {
                              
                             authService.loginConfirmed(data);
                            }).catch(function(response) {
                                if (response.status != 0) {
                                    $rootScope.authenticationError = false;
                                    TokenService.remove();

                                    $http.get('app/logout');
                                    $rootScope.account = null;
                                    $state.go('user');
                                }
                            });

                                const companyId = param.companyId;
                                $state.go('company', {companyId, reg: password});
                                localStorage.setItem('loginAttempts', 0);
                                $rootScope.captchaError = false;
                        });
                        },
                        login: function (param) {
                            $rootScope.authenticationError = false;
                            var redirection = $state.params.redirect;
                            var username = param.username;
                            var password = param.password;
                            if (redirection != null) {
                                var idx = redirection.indexOf("/loginSaml/client/sso/");
                                var tmp = redirection;
                            } else {
                                var idx = $location.absUrl().indexOf("/loginSaml/client/sso/");
                                var tmp = $location.absUrl();
                            }
                            if (idx > -1) {
                                var tracker = tmp.substring(idx + "/loginSaml/client/sso/".length, tmp.length);
                                if (tracker != null) {
                                    if (username == null) {
                                        username = "tracker";
                                    }
                                    if (password == null) {
                                        password = tracker;
                                    }
                                }
                            }

                            if (redirection != null) {
                                var idx = redirection.indexOf("/ssosaaspass/");
                                var tmp = redirection;
                            } else {
                                var idx = $location.absUrl().indexOf("/ssosaaspass/");
                                var tmp = $location.absUrl();
                            }
                            if (idx > -1) {
                                var content = tmp.substring(idx + "/ssosaaspass/".length, tmp.length);
                                if (content != null) {
                                    if (username == null) {
                                        username = "ssosaaspass";
                                    }
                                    if (password == null) {
                                        password = content;
                                    }
                                }
                            }

                            var data = "username="
                                    + encodeURIComponent(username)
                                    + "&password="
                                    + encodeURIComponent(password)
                                    + "&grant_type=password&scope=read%20write&client_secret=mySecretOAuthSecret&client_id=SaaSPassapp";
                            
                            if (param.oauthClientId != null) {
                                data += "&oauth_client_id=" + param.oauthClientId;
                            }
                            if (param.captchaResponse != null) {
                                data += "&captchaResponse=" + param.captchaResponse;
                            }
                            if (param.googleAppsLogin) {
                                data += '&googleAppsLogin=' + param.googleAppsLogin;
                                data += '&code='+param.code;
                            }
                            if(param.googleMarketPlaceConfiguration){
                                data += "&gmpConfig="+param.googleMarketPlaceConfiguration;
                                data += "&code="+param.code;
                                data += "&domain="+param.domain;
                                
                            }
                            if (redirection != null && redirection.indexOf('/loginSAML/') > -1) {
                                var appKey = redirection.replace(/\/loginSAML\/(.*)/, '$1');
                                data += "&appKey=" + appKey;

                                if (param.passwordLogin) {
                                    data += '&passwordLogin=' + param.passwordLogin;
                                }
                            }
                            var idxSSO = $location.absUrl().indexOf("/loginSaml/client/sso/");
                            if(idxSSO > -1){
                                data+="&tracker=" + password;
                            }
                            
                            

                            const promise = $http.post(
                                    'oauth/token',
                                    data,
                                    {
                                        headers : {
                                            "Content-Type" : "application/x-www-form-urlencoded",
                                            "Accept" : "application/json",
                                            "Authorization" : `Basic ${btoa('SaaSPassapp:mySecretOAuthSecret')}`
                                        },
                                        ignoreAuthModule : 'ignoreAuthModule'
                                    }).then((response) => {
                                        if($rootScope.loginModal){
                                            $rootScope.loginModal.close();
                                        }
                                $rootScope.refreshers = [];
                                TokenService.setToken(response.data);
                                
                                // Saaspass Connect login request check
                                var continueUrl;
                                const continueParam = $state.params.continue;
                                if(continueParam){
                                    $('#clientDisplayName').text('Please wait...');
                                    continueUrl = decodeURI(continueParam);
                                }
                                
                                Account.reload().then(function (data) {
                                    if (data.userEmailAddress) {
                                        
                                        var redirection = $state.params.redirect;
                                        if(param.googleMarketPlaceConfiguration){
                                            gmpLoginSession = true;
                                            redirection = $state.href('gmp-config');
                                        }
                                        if($state.is('public.gmarket-login')){
                                            redirection = $state.href('gmp-config');
                                        }
                                        
                                        if (redirection != null) {
                                            $location.path(redirection);
                                            $location.url($location.path());
                                        }
                                    }
                                    
                                    // Saaspass Connect login request check
                                    if(continueUrl){
                                        $window.location.href = continueUrl;                                     
                                    }else{
                                        authService.loginConfirmed(data);
                                    }                                                                       
                                }).catch(function(response) {
                                    if (response.status != 0) {
                                        $rootScope.authenticationError = false;
                                        TokenService.remove();

                                        $http.get('app/logout');
                                        $rootScope.account = null;
                                        $state.go('user');
                                    }
                                });

                                var redirection = $state.params.redirect;
                                if(param.googleMarketPlaceConfiguration){
                                    gmpLoginSession = true;
                                }
                                if (param.googleAppsLogin) {
                                    redirection = '/applications';
                                }
                                if (redirection != null && redirection.indexOf('/ssosaaspass/') > -1) {
                                    redirection = '/authenticator';
                                }
                                if (redirection == null || redirection == '') {
                                        var idx = $location.absUrl().indexOf("/loginSaml/client/sso/");
                                        var tmp = $location.absUrl();
                                    if (idx > -1) {
                                        var tracker = tmp.substring(idx + "/loginSaml/client/sso/".length, tmp.length);
                                    }
                                    if (tracker == null) {
                                        redirection = '/authenticator';
                                    }

                                } else if (redirection.indexOf('/loginSaml/client/sso') > -1) {
                                    redirection = null;
                                } else if (redirection.indexOf('/loginSAML') > -1) {

                                    redirection += `?SAMLTracker=${encodeURIComponent($location.search().SAMLTracker)}`;

                                    try {
                                        var targeting = '_self';
                                        $window.open('#' + redirection, targeting);
                                    } catch (e) {
                                        console.log(e);
                                    }

                                    redirection = $state.href('user');
                                }
                                if (redirection != null) {
                                    if(continueUrl){
                                        return;
                                    }else{
                                        $location.path(redirection);
                                        $location.url($location.path());
                                    }
                                }
                                localStorage.setItem('loginAttempts', 0);
                                $rootScope.captchaError = false;                                    
                                
                            });

                            promise.catch((response) => {
                                        const data = response.data;
                                        if (data.error_description && data.error_description.indexOf('Google') > -1) {
                                            $state.go('public.google-info');
                                            return;
                                        }else if (data.error_description && data.error_description.indexOf('captcha') > -1) {
                                            $rootScope.captchaError = true;
                                            if (!localStorage.getItem('loginAttempts')) {
                                                $rootScope.captchaErrorMsg = 'login.messages.error.invalid_captcha_first_time';
                                                if($state.is('public.hard-token-login')){
                                                    $rootScope.topLevelMessage = new SpAlert('danger', $rootScope.captchaErrorMsg);
                                                }
                                            } else {
                                                $rootScope.captchaErrorMsg = 'login.messages.error.invalid_captcha';
                                                if($state.is('public.hard-token-login')){
                                                    $rootScope.topLevelMessage = new SpAlert('danger', $rootScope.captchaErrorMsg);
                                                }
                                            }
                                        } else {
                                            $rootScope.captchaError = false;
                                        }
                                        $rootScope.authenticationError = true;
                                        if(!$rootScope.loginModal){
                                            setInvalidAttempts(data);
                                            $rootScope.account = null;
                                            TokenService.remove();
                                            if($state.is('public.hard-token-login')){
                                                const key = 'login.messages.error.authenticationToken';
                                                $rootScope.topLevelMessage = new SpAlert('danger', key);
                                            }else{
                                                $rootScope.$broadcast('event:auth-loginRequired', data);
                                            }
                                        }                                        
                                    });

                            return promise;
                        },
                        refresh : function() {

                            if ($rootScope.transition.to().name.startsWith('public.')) {
                                $rootScope.account = null;
                                TokenService.remove();
                                $rootScope.sessionExpired = true;
                                return;
                            }

                            var token = TokenService.getAccessToken();

                            if (!token) {
                                // the token is removed, logout occured.
                                $rootScope.account = null;

                                    var redirect = $location.path();
                                    if (redirect.indexOf("loginSAML") != -1) {
                                        $state.go('public.login', {redirect}, {location: 'replace'});
                                    }else if(redirect.indexOf("gmarketlogin") != -1) {
                                        $location.path(redirect);
                                    }
                                    else {
                                        if (!$rootScope.sessionExpired) {
                                            $state.go('public.login');
                                        } else {
                                            $state.go('public.session-expired');
                                        }
                                    }

                                return;
                            }

                            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                                return v.toString(16);
                            });

                            if (!angular.isDefined($rootScope.refreshers)) {
                                $rootScope.refreshers = [];
                            }

                            $rootScope.refreshers.push(uuid);

                            var refreshPromise = $rootScope.$watch('refreshers', function() {
                                // TODO I am seeing dead people!
                                if (!$rootScope.refreshers || !$rootScope.refreshers.length) {
                                    // something happend there
                                    // are no refreshers
                                    // avalible, do not care :)
                                    // relase the promise!
                                    refreshPromise();
                                }

                                var currentTurnUuid = $rootScope.refreshers[0];
                                if (uuid !== currentTurnUuid) {
                                    return;
                                }
                                var currentKnownToken = {};
                                if (TokenService.getAccessToken()) {
                                    currentKnownToken = TokenService.getAccessToken();
                                }

                                if (currentKnownToken === token) {
                                    
                                    $http.post(
                                            'oauth/token',
                                            `refresh_token=${TokenService.getRefreshToken()}&grant_type=refresh_token`,
                                            {
                                                headers : {
                                                    "Content-Type" : "application/x-www-form-urlencoded",
                                                    "Accept" : "application/json",
                                                    "Authorization" : `Basic ${btoa('SaaSPassapp:mySecretOAuthSecret')}`
                                                },
                                                ignoreAuthModule : 'ignoreAuthModule'
                                            }).then((response) => {
                                                const data = response.data;
                                                TokenService.setToken(data);
                                                authService.loginConfirmed(data);
                                                $rootScope.refreshers.shift();
                                                // revoke
                                                // all
                                                // watchers
                                                var notAccountWatches = [];
                                                angular.forEach($rootScope.$$watchers, function(value, key) {
                                                    if (value.exp !== 'refreshers') {
                                                        notAccountWatches.push(value);
                                                    }
                                                });
                                                $rootScope.$$watchers = notAccountWatches;
                                                $rootScope.refreshers = [];
                                                $rootScope.refreshers.shift();
                                                refreshPromise();
                                            })
                                            .catch(() => {
                                                        authService.loginCancelled();
                                                        $rootScope.refreshers.shift();
                                                        // revoke
                                                        // all
                                                        // watchers
                                                        var notAccountWatches = [];
                                                        angular.forEach($rootScope.$$watchers, function(value, key) {
                                                            if (value.exp !== 'refreshers' && value.exp !== 'account') {
                                                                notAccountWatches.push(value);
                                                            }
                                                        });
                                                        $rootScope.$$watchers = notAccountWatches;
                                                        $rootScope.refreshers = [];
                                                        TokenService.remove();
                                                        $rootScope.account = null;
                                                        $rootScope.sessionExpired = true;

                                                            var redirect = $location.path();
                                                            if (redirect.indexOf("loginSAML") != -1) {
                                                                $state.go('public.login', {redirect}, {location: 'replace'});
                                                            }
                                                            $state.go('public.session-expired');

                                                        $rootScope.refreshers.shift();
                                                        refreshPromise();
                                                    });
                                } else {
                                    refreshPromise();
                                    // revoke all watchers
                                    var notAccountWatches = [];
                                    angular.forEach($rootScope.$$watchers, function(value, key) {
                                        if (value.exp !== 'refreshers') {
                                            notAccountWatches.push(value);
                                        }
                                    });
                                    $rootScope.$$watchers = notAccountWatches;
                                    $rootScope.refreshers = [];
                                }
                            });

                        },
                        logout : function() {
                            $rootScope.authenticationError = false;
                            TokenService.remove();
                            $http.get('app/logout');
                            $rootScope.account = null;
                            $window.location.href = "https://www.saaspass.com";
                        }
                    };
}



// WEBPACK FOOTER //
// ./src/portal/services/authentication-shared.service.js